import client from 'lib/sitecore-client';

type GraphQLClientLike = {
  request: <T>(query: string, variables?: Record<string, unknown>) => Promise<T>;
};

// Returns a GraphQL client backed by the CSDK SitecoreClient.
// The config parameter is accepted for backwards compatibility but is no longer used.
export async function getGraphQLClientAsync(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _config?: unknown
): Promise<GraphQLClientLike> {
  return {
    request: <T>(query: string, variables?: Record<string, unknown>) =>
      client.getData<T>(query, variables),
  };
}
